import { IColumn } from '../types';
import { defaultHeaderRenderer } from '../headers';
import { CellProps } from '../../types';
import { CellEventsHandler } from '../formatters';

const Formatter = (cellProps: CellProps) => {
  return <CellEventsHandler cellProps={cellProps}>{cellProps.row.nationality}</CellEventsHandler>;
};

export const NationalityColumn = (): IColumn => ({
  item: {
    key: 'nationality',
    name: 'Nationality',
    width: 'minmax(104px, .75fr)',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    responsive: true,
    formatter: Formatter,
  },
  visible: () => true,
});
